import React from "react";
import { ITextureSwatchProps, UiTextureSwatch } from "./ui";

interface IState {}

export class TextureSwatch<T> extends React.Component<ITextureSwatchProps<T>, IState> {

  public render() {
    return (<UiTextureSwatch {...this.props} />);
  }
}